__webpack_require__.p = "https://wastehero-frontend-fbo2tj0iu-wastehero.vercel.app/";